import { useEffect, useState } from 'react';
import PMGProjectIcon from '../../assets/icons/pmg-project.svg';
import Button from '../../components/Button/Button';
import SearchBar from '../../components/Common/SearchBar/SearchBar';
import CustomPagination from '../../components/Common/CustomPagination/CustomPagination';
import CustomTable from '../../components/Common/CustomTable/CustomTable';
import AddProject from '../../components/Modals/AddProject';
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addPmgProject, editPmgProject, getMSCode, getPmgProjectListing } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import openNotification from '../../components/Common/OpenNotification';
import { useNavigate } from 'react-router-dom';

const PmgProjectsPage = () => {
        const navigate = useNavigate();
        const [searchValue, setSearchValue] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editProject, setEditProject] = useState({});
        const [ioNo, setIoNo] = useState('');
        const dispatch = useDispatch();
        const { pmgProjectListing, totalPmgProjectListing } = useSelector((state) => state.unitReport);

        const handleAdd = async (formData) => {
                let response;
                if (editProject && Object.keys(editProject).length > 0) {
                        response = await dispatch(editPmgProject(formData));
                } else {
                        response = await dispatch(addPmgProject(formData));
                }

                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getPmgProjectListing({
                                        page: currentPage,
                                        size: '10',
                                        IO_NO: ioNo,
                                        search: searchValue,
                                }),
                        );
                        openNotification('success', editProject?.IO_NO ? 'Updated' : 'Added', 'Success');
                        setIsModalOpen(false); // ✅ Only close on success
                }

                return { status }; // ✅ Return status for child to handle
        };

        const pageSize = 10; // Items per page
        const columns = [
                {
                        title: 'Project Name',
                        dataIndex: 'PROJ_NAME',
                        key: 'PROJ_NAME',
                        width: 250,
                        fixed: 'left',
                        render: (text, record) => (
                                <div className="flex items-center justify-between gap-2">
                                        <span>{text}</span>
                                        <EditOutlined
                                                className="text-blue-500 cursor-pointer"
                                                onClick={() => {
                                                        setEditProject(record);
                                                        setIsModalOpen(true);
                                                }}
                                        />
                                </div>
                        ),
                },
                {
                        title: 'IO Number',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Rev No.',
                        dataIndex: 'REV_NO',
                        key: 'REV_NO',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'PID',
                        dataIndex: 'PID',
                        key: 'PID',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'MS Code',
                        dataIndex: 'MS_CODE',
                        key: 'MS_CODE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Zero Date',
                        dataIndex: 'ZERO_DATE',
                        key: 'ZERO_DATE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Scheduled Date',
                        dataIndex: 'SCHEDULE_DATE',
                        key: 'SCHEDULE_DATE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Expected Date',
                        dataIndex: 'EXPECTED_DATE',
                        key: 'EXPECTED_DATE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Actual Date',
                        dataIndex: 'ACTUAL_DATE',
                        key: 'ACTUAL_DATE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'MW',
                        dataIndex: 'MW',
                        key: 'MW',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Unit No',
                        dataIndex: 'UNIT_NO',
                        key: 'UNIT_NO',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'P Type',
                        dataIndex: 'PTYPE',
                        key: 'PTYPE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
                {
                        title: 'Sub Type',
                        dataIndex: 'SUB_TYPE',
                        key: 'SUB_TYPE',
                        width: 150,
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                },
        ];

        useEffect(() => {
                dispatch(
                        getPmgProjectListing({
                                page: currentPage,
                                size: '10',
                                IO_NO: ioNo,
                                search: searchValue,
                        }),
                );
        }, [currentPage, searchValue]);

        useEffect(() => {
                dispatch(getMSCode());
        }, []);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-4">
                                <div className="flex gap-3">
                                        {/* <img
                                                src={PMGProjectIcon}
                                                alt="region"
                                        /> */}
                                        <div>
                                                <div className="font-inter font-semibold text-[18px] leading-[24px] tracking-[0%] text-[#101828]">Projects</div>
                                                <div className="font-inter font-normal text-[13px] leading-[20px] tracking-[0%] text-[#475467]">List of projects</div>
                                        </div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in lakhs).</div>
                                <div className="mt-[8px] flex justify-between">
                                        <SearchBar
                                                className="!w-[330px]"
                                                onSearch={setSearchValue}
                                                placeholder="Search by Project Name or IO Number"
                                        />
                                        <div className="flex gap-[12px]">
                                                <Button
                                                        text="Upload"
                                                        variant="primary"
                                                        onClick={() => {
                                                                navigate('/pmg-projects/upload-files');

                                                                // setIsModalOpen(true);
                                                                // setEditProject({});
                                                        }}
                                                />
                                        </div>
                                </div>
                                <div className=" flex flex-col gap-6">
                                        <CustomTable
                                                dataSource={pmgProjectListing}
                                                columns={columns}
                                        />
                                        <div>
                                                <CustomPagination
                                                        totalItems={totalPmgProjectListing}
                                                        pageSize={pageSize}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                />
                                        </div>
                                </div>
                                <AddProject
                                        open={isModalOpen}
                                        onCancel={() => {
                                                setIsModalOpen(false);
                                                setEditProject({});
                                        }}
                                        onSubmit={handleAdd}
                                        initialData={editProject}
                                        setEditProject={setEditProject}
                                />
                        </div>
                </div>
        );
};

export default PmgProjectsPage;
